/*
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLCanvasElement
import react.dom.render


fun main() {

    window.onload = {
        render(document.getElementById("root")) {
            child(Welcome::class) {
                attrs {
                    name = "Kotlin/JS"
                }
            }
        }
    }

    renderToCanvas(document.getElementById("sp_canvas") as HTMLCanvasElement)
}
*/

import com.starparty.app.astro0.SP_Place
import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.js.CanvasState
import com.starparty.app.astro0.js.Controls
import com.starparty.app.astro0.js.SP_JSCanvas
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLMetaElement
import org.w3c.dom.get
import org.w3c.dom.url.URLSearchParams
import kotlin.js.Date
import kotlin.math.absoluteValue


var urlParams = params()
var timeZoneOffsetHours = 0
var timeZoneOffsetMins = 0
var dateTime = initialiseDateTime()
var latLong = initialisePlace()
val sky = Sky(dateTime, latLong.latitude, latLong.longitude)
val spCanvas = initalizeCanvas()
val cs = CanvasState(sky, spCanvas).apply {
}
val controls = Controls(sky, cs)


fun params() : URLSearchParams {

    val url = window.location.search
    val params = URLSearchParams(url)

    return params
}

fun initialisePlace(): SP_Place
{
    val latLong = SP_Place()

    val latParam = urlParams.get("lat")
    val lat = latParam.toString().toDoubleOrNull()

    val lonParam = urlParams.get("lon")
    val lon = lonParam.toString().toDoubleOrNull()

    if (null != lat)
    {
        latLong.latitude = lat
    }

    if (null != lon)
    {
        latLong.longitude = lon
    }

    return latLong
}

fun initialiseDateTime(): SP_Time {
    val nowUTC = Date.now()
    val date = Date(nowUTC)
    val year = date.getUTCFullYear()
    val month = date.getUTCMonth() // zero indexed Jan=0
    val day = date.getUTCDate()
    val hour = date.getUTCHours()
    val min = date.getUTCMinutes()
    val sec = date.getUTCSeconds()
    //  console.log("utcms:$nowUTC,$year, $month, $day, $hour, $min, $sec")

    initialiseTimeZoneOffset()

    return SP_Time(year, month + 1, day, hour, min, sec)
}

fun initialiseTimeZoneOffset() {

    val tzoParam = urlParams.get("tzo")
    val tzoMins = tzoParam.toString().toDoubleOrNull()

    if (null != tzoMins) {

        val tzo = tzoMins / 60.0
        if (tzo >= -14.0 && tzo <=14.0 ) {
            timeZoneOffsetHours = tzo.toInt()
            timeZoneOffsetMins = ((tzo - timeZoneOffsetHours).absoluteValue * 60.0).toInt()

            if (timeZoneOffsetMins != 15 &&
                timeZoneOffsetMins != 30 &&
                timeZoneOffsetMins != 45 ) {

                timeZoneOffsetMins = 0
            }

           // console.log("tzoh:$timeZoneOffsetHours tzom:$timeZoneOffsetMins")
        }
    }
}

fun initalizeCanvas(): SP_JSCanvas {

    val htmlCanvas = document.createElement("canvas") as HTMLCanvasElement
    val spCanvas = SP_JSCanvas(htmlCanvas)

    val ctx = htmlCanvas.getContext("2d") as CanvasRenderingContext2D
    ctx.canvas.width  = window.innerWidth
    ctx.canvas.height = window.innerHeight

    val xOffset = spCanvas.width / 2.0
    val yOffset = spCanvas.height * (4.0/5.0)
    spCanvas.translate(xOffset, yOffset)

  //  document.body!!.appendChild(htmlCanvas)

    return spCanvas
}

/*fun setupKeyboard(){
    window.onload = {
        document.onkeypress = { e: KeyboardEvent ->

            if (e.keyCode == 33) { // Pageup
                console.log("Page up ")
            }
            if (e.keyCode == 34) { // Pagedown
console.log("Page down ")
            }
            Unit
        }
        Unit
    }
}*/

fun main(args: Array<String>) {

    var spData = ""

    try {
        val spDataElement = document.getElementsByName("starparty-data").get(0) as HTMLMetaElement
        spData = spDataElement.content
    }
    catch(e:Exception) {}

//console.log("spData: $spData")
    val hideLocationControls = spData.contains("hide-location-controls")

    controls.setupDateTimeControls(timeZoneOffsetHours, timeZoneOffsetMins)
    controls.setupZoomButtons()
    controls.setupRotateButtons()

    if ( ! hideLocationControls) {
            controls.setupLocationSpinners()
    }
    controls.setupDirectionButtons()
    controls.setupShowButtons()
    controls.setupCanvas()
}
